<template>
    <el-row :gutter="20">
        <el-col :md="24" :sm="24" class="mb-3">
            <el-card class="profile" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="mb-3">调查统计<span class="ml-3"></span></div>
                    <el-form :inline="true" :model="search" class="report-form-inline">
                        <el-form-item label="选择时间">
                            <el-select v-model="search.short_cut" @change="handleCalculate">
                                <el-option label="六个月内" :value="6"></el-option>
                                <el-option label="一年内" :value="12"></el-option>
                                <el-option label="两年内" :value="24"></el-option>
                                <el-option label="三年内" :value="36"></el-option>
                                <el-option label="所有时间" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="">
                            <el-checkbox v-model="search.select_date"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="起始日期">
                            <el-date-picker value-format="yyyy-MM-dd" :disabled="!search.select_date" type="date"
                                            placeholder="选择起始日期" v-model="search.begin_date"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期">
                            <el-date-picker value-format="yyyy-MM-dd" :disabled="!search.select_date" type="date"
                                            placeholder="选择结束日期" v-model="search.end_date"></el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="handleCalculate"><i class="el-icon-refresh"></i> 计算
                            </el-button>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="info" @click="handleDownload"><i class="el-icon-download"></i> 下载报表
                            </el-button>
                        </el-form-item>

                    </el-form>
                </div>
                <div style="" v-show="!show_table">
                    <div class="mb-4 border-bottom" style="height: 300px;" :id="'echart_'+q.id" :ref="'echart_'+q.id"
                         v-for=" q in questions" :key="q.id">

                    </div>
                </div>
                <div v-show="show_table" ref="excel_table">
                    <el-table border size="small"
                              :data="table.data" show-summary
                              style="width: 100%">
                        <el-table-column v-for="header in table.headers" :key="header.prop"
                                         :prop="header.prop"
                                         :label="header.label">
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </el-col>
    </el-row>

</template>

<script>

    import echarts from "echarts"
    import {mapState, mapMutations} from "vuex";
    import FileSaver from 'file-saver';
    import XLSX from 'xlsx';

    export default {
        name: "statistic",
        data() {
            return {
                search: {
                    begin_date: '',
                    end_date: '',
                    select_date: false,
                    short_cut: 6,
                },
                echarts: {},
                show_table: false,
                questions: {},
                table: {headers: [], data: []}
            }
        },
        computed: {
            ...mapState(['user', 'process']),
        },
        mounted() {
            //this.my_charts = echarts.init(this.$refs['echarts_content']);
            this.handleCalculate();
        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            handleDownload() {
                this.$api('Report.Survey.Download', this.search, true).then((res) => {
                    const data = res.data.data;
                    this.table.headers = data.headers;
                    this.table.data = data.data;
                    this.show_table = true;
                    this.$nextTick(function () {
                        this.exportExcel();
                    })
                });
            },
            // 导出表格
            exportExcel() {
                /* generate workbook object from table */
                let wb = XLSX.utils.table_to_book(this.$refs['excel_table']);
                /* get binary string as output */
                let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
                let now = new Date().Format('yyyy-MM-dd');
                try {
                    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `调研统计表-${now}.xlsx`)
                } catch (e) {
                    console.log(e, wbout)
                }
                return wbout
            },
            handleCalculate() {
                this.calStatistic();
                this.show_table = false;
            },
            calStatistic() {
                this.$api('Report.Survey.Get', this.search, true).then((res) => {
                    const data = res.data.data;
                    this.questions = data;

                    this.$nextTick(function () {
                        for (let x in this.questions) {
                            const question = this.questions[x];
                            const dom = this.$refs['echart_' + x][0];

                            if (!this.echarts[x]) {
                                this.echarts[x] = echarts.init(dom);
                            }

                            let option = {
                                title: {text: question.question},
                                tooltip: {},
                                yAxis: {},
                                series: [],
                                legend: {
                                    data: data.legend
                                },
                                toolbox: {
                                    show: true,
                                    feature: {
                                        magicType: {show: true, type: ['line', 'bar']},
                                        saveAsImage: {show: true}
                                    }
                                },
                            };

                            if (question.type === '1') {
                                option.xAxis = {
                                    data: [1, 2, 3, 4, 5],
                                    axisLabel: {
                                        interval: 0,
                                        rotate: 0
                                    }
                                };
                                let data=[];
                                question.answer.forEach((x,index)=>{
                                    if (index>0) data.push(x);
                                });
                                option.series.push({
                                    type: 'bar',
                                    data:data ,
                                });

                            } else {
                                option.xAxis = {
                                    data: Object.keys(question.answer),
                                    axisLabel: {
                                        interval: 0,
                                        rotate: 0
                                    }
                                };

                                let data = [];
                                for (let item in question.answer) {
                                    data.push(question.answer[item])
                                }
                                option.series.push({
                                    type: 'bar',
                                    data: data,
                                });

                            }

                            this.echarts[x].setOption(option);
                        }
                    });
                })
            },
        },
        created() {
            let d = new Date();
            this.search.end_date = d.Format('yyyy-MM-dd');
            d.setFullYear(d.getFullYear() - 1);
            this.search.begin_date = d.Format('yyyy-MM-dd');
        }
    }
</script>

<style scoped lang="scss">

    .report-form-inline {
        .el-form-item {
            margin-bottom: 0;
        }
    }


</style>
